// Platform-kapu — EGYETLEN forrás arra, hogy natív burkolatban (iOS/Android)
// fut-e a kód, és hogy ebből mi következik a dózis-funkciókra.
//
// Miért (2026-09-01): az App Review Board elutasította az 1.4.2-es
// fellebbezést (APL531603) — a dózis-SZÁMOLÓ funkciók a natív appban nem
// maradhatnak. A web érintetlen marad, teljes eszköztárral.
//
// A határvonal (App Store-ban lévő versenytárs bejárása alapján):
//   „naplózott adatból származtatott"  → elfogadott
//   „beírsz egy mg-ot, kapsz egy mg-ot" → kalkulátor, natívon tilos
//
// FONTOS, ami ebből NEM következik: a felhasználó SAJÁT, általa rögzített
// dózisának megjelenítése (napló, „Utolsó dózis", dózis-előzmény a PDF-ben,
// grafikon-pöttyök) natívon is marad — az adat megjelenítése nem számítás
// és nem javaslat.
//
// Ez a fájl a kapu egyetlen helye: máshol NE hívj közvetlenül
// `Capacitor.isNativePlatform()`-ot dózis-döntéshez, innen olvass.
import { Capacitor } from "@capacitor/core";

import type { ToolId } from "../pages/Eszkozok";

/** Tiszta döntésfüggvény — a konstans is ezt hívja, a unit teszt pedig
 * mindkét ágat le tudja fedni `@capacitor/core` mockolás nélkül. */
export function resolveDoseFeaturesEnabled(isNative: boolean): boolean {
  return !isNative;
}

/** Igaz, ha Capacitor natív burkolatban futunk (iOS/Android), nem böngészőben. */
export const IS_NATIVE = Capacitor.isNativePlatform();

/** Dózis-SZÁMOLÓ funkciók engedélyezettek-e ezen a platformon. */
export const DOSE_FEATURES_ENABLED = resolveDoseFeaturesEnabled(IS_NATIVE);

/**
 * Az eszközök, amelyek natívon NEM léteznek — nem „letiltva", hanem nincsenek:
 * se menüpont, se útvonal, se szöveg, és az AI sem hivatkozhat rájuk.
 *
 * Indoklás eszközönként:
 *  - kalkulator  — titrálási séma alapján mg-ot ír ki (a legerősebb eset)
 *  - kattintas   — kattintás ↔ mg ↔ ml oda-vissza átváltás
 *  - microdose   — heti mg-ot oszt injekciónkénti mg-ra
 *  - titralo     — dátumozott dózisemelési ütemterv
 *  - plotter     — mg-választó + mg-értékű eredmény (Build 12-ben átalakul
 *                  naplózott dózisból számoló nézetté, lásd a ClickUp-jegyet)
 *  - kimaradt    — statikus és forrásolt, de a témája („mit tegyek, ha
 *                  kimaradt") az, amit az Apple orvosi tanácsként olvas
 */
export const NATIVE_HIDDEN_TOOLS: readonly ToolId[] = [
  "kalkulator",
  "kattintas",
  "microdose",
  "titralo",
  "plotter",
  "kimaradt",
] as const;

/** Natívon ez az alapértelmezett eszköz (a `plotter` ott nem létezik). */
export const NATIVE_DEFAULT_TOOL: ToolId = "feherje";

/** Tiszta függvény: látható-e az adott eszköz ezen a platformon. */
export function isToolVisible(toolId: ToolId, isNative: boolean): boolean {
  if (!isNative) return true;
  return !NATIVE_HIDDEN_TOOLS.includes(toolId);
}
